import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-school-onboarding',
  imports: [RouterOutlet],
  templateUrl: './school-onboarding.html',
  styleUrl: './school-onboarding.css',
})
export class SchoolOnboarding {}
